import { isDefined } from "@omni/utils/helper.utils";
import { useEffect, useState } from "react";

import { createApiFor } from "@/api/hooks/utils";
import {
    CustomerOrderListMapper,
    CustomerOrderListModel,
    CustomerOrderListResponse
} from "@/api/mappers/customerOrderList.mapper";
import { Config } from "@/utils/config.utils";

export const CUSTOMER_ORDER_LIST_PAGE_SIZE = 10;

const cartServiceApi = createApiFor(`/${Config.general.basestore}`, {
    bff: true
});

const fetchOrders = (currentPage: number, page: number) =>
    cartServiceApi
        .get<CustomerOrderListResponse>("/orders/customer", {
            params: {
                page: page - 1,
                pageSize: (page - currentPage) * CUSTOMER_ORDER_LIST_PAGE_SIZE
            }
        })
        .then(({ data }) => CustomerOrderListMapper(data));

export type CustomerOrderList = CustomerOrderListModel & {
    currentPage: number;
};

const defaultCustomerOrderList: CustomerOrderList = {
    orders: [],
    totalElements: 0,
    currentPage: 0
};

export const useOrderList = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [customerOrderList, setCustomerOrderList] = useState<
        CustomerOrderList | undefined
    >(undefined);

    const loadOrderList = async (page: number) => {
        setLoading(true);

        const fetchedCustomerOrderList = await fetchOrders(
            customerOrderList?.currentPage ?? 0,
            page
        );

        setCustomerOrderList((currentCustomerOrderList) => ({
            orders: [
                ...(currentCustomerOrderList?.orders ?? []),
                ...fetchedCustomerOrderList.orders
            ],
            currentPage: page,
            totalElements: fetchedCustomerOrderList.totalElements
        }));
        setLoading(false);
    };

    const loadNextPage = () =>
        loadOrderList((customerOrderList?.currentPage ?? 0) + 1);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (isDefined(customerOrderList)) return;

        loadNextPage();
    }, [customerOrderList]);

    return {
        customerOrderList: customerOrderList ?? defaultCustomerOrderList,
        loading: loading,
        loadNextPage: loadNextPage
    };
};
